package com.cybersoftsolution.cybersoftsolutionweb.components.navigation

import androidx.compose.runtime.Composable
import com.cybersoftsolution.cybersoftsolutionweb.navigation.Screen
import com.cybersoftsolution.cybersoftsolutionweb.navigation.navigateTo
import com.cybersoftsolution.cybersoftsolutionweb.utils.Resources
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.ScrollBehavior
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.scrollBehavior
import com.varabyte.kobweb.core.PageContext
import org.jetbrains.compose.web.css.px

@Composable
fun HomeNavigationItems(context: PageContext){

    Column(
        modifier = Modifier
            .fillMaxWidth()
            .padding(left = 10.px)
            .overflow(Overflow.Auto)
            .scrollBehavior(ScrollBehavior.Smooth)
    ) {
        NavigationItemNew(
            title = "Panel de Administración",
            icon = Resources.PathIconsVectors.admin_panel_ico,
            onClick = {
                context.navigateTo(Screen.AdminRoot)
            }

        )
    }



}